var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSwaziland(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5003:53784)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.4124 22.9903C31.4295 20.8868 32 18.5269 32 16.0338C32 13.5407 31.4295 11.1807 30.4124 9.07728L16 8.38159L1.58763 9.07722C0.5705 11.1807 0 13.5407 0 16.0338C0 18.5269 0.5705 20.8868 1.58763 22.9903L16 23.686L30.4124 22.9903Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9998 0.0341797C9.6564 0.0341797 4.1754 3.72574 1.5874 9.07768H30.4121C27.8242 3.72574 22.3431 0.0341797 15.9998 0.0341797V0.0341797Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9998 32.0344C9.6564 32.0344 4.1754 28.3429 1.5874 22.9909H30.4121C27.8242 28.3429 22.3431 32.0344 15.9998 32.0344V32.0344Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2444 11.1647H0.755562C0.265437 12.7003 0 14.3362 0 16.0343C0 17.7323 0.265437 19.3683 0.755562 20.9038H31.2444C31.7346 19.3683 32 17.7323 32 16.0343C32 14.3362 31.7346 12.7003 31.2444 11.1647Z",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.56519 15.3384H26.4347V16.7298H5.56519V15.3384Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.34839 12.5563H23.6528V13.9476H8.34839V12.5563Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7517 16.0344C23.7517 16.0344 20.174 20.2083 16.0001 20.2083C11.8262 20.2083 11.8262 16.0344 11.8262 16.0344C11.8262 16.0344 11.8262 11.8604 16.0001 11.8604C20.1741 11.8604 23.7517 16.0344 23.7517 16.0344Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0003 20.2083C11.8264 20.2083 8.24878 16.0344 8.24878 16.0344C8.24878 16.0344 11.8264 11.8604 16.0003 11.8604",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2168 14.6426H14.6081V17.4253H13.2168V14.6426Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3906 14.6426H18.7819V17.4253H17.3906V14.6426Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.56587 17.4253C6.33427 17.4253 6.95719 16.8023 6.95719 16.0339C6.95719 15.2655 6.33427 14.6426 5.56587 14.6426C4.79747 14.6426 4.17456 15.2655 4.17456 16.0339C4.17456 16.8023 4.79747 17.4253 5.56587 17.4253Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4355 17.4253C27.2039 17.4253 27.8268 16.8023 27.8268 16.0339C27.8268 15.2655 27.2039 14.6426 26.4355 14.6426C25.6671 14.6426 25.0442 15.2655 25.0442 16.0339C25.0442 16.8023 25.6671 17.4253 26.4355 17.4253Z",
    fill: "#0052B4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5003:53784"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.0341797)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwaziland);
export default __webpack_public_path__ + "static/media/swaziland.2e9f0d79.svg";
export { ForwardRef as ReactComponent };